import { gql, TypedDocumentNode } from '@apollo/client';

import type {
  EffectiveConsentPreferenceQuery,
  EffectiveConsentPreferenceQueryVariables,
} from '@/api/gql/graphql';

export const EFFECTIVE_CONSENT_PREFERENCE: TypedDocumentNode<
  EffectiveConsentPreferenceQuery,
  EffectiveConsentPreferenceQueryVariables
> = gql`
  query effectiveConsentPreference {
    data: effectiveConsentPreference {
      preference {
        consentGivenAt
        preferences {
          purpose
          value
        }
      }
      error {
        code
        message
      }
    }
  }
`;
